import { createContext } from "react";

const CompeteContext = createContext(undefined as any);

export default CompeteContext;
